
import { getUrlParameter, hasUrlParameter, setCookie, getCookie, delCookie, setModalDisplayFlexToCenterItOnOpen, getCurrenLocaleObj } from "../functions";

$(function() {
    const currenLocaleObj = getCurrenLocaleObj();

    const memberNotificationWrapper = $('.member-notifications-wrapper');
    const memberNotification = $('.member-notification');
    if (memberNotificationWrapper.length && memberNotification.length) {
        const countEl = $('.mn-count');

        memberNotification.find('.text a, .close').on('click touch', function(e) {
            const $this = $(this),
                mainParent = $(this).parents('.member-notification'),
                closeButton = mainParent.find('.close'),
                type = mainParent.data('type'),
                id = mainParent.data('id'),
                formData = {
                    id, type
                };

            if (countEl.length && closeButton.length && closeButton.is(':visible')) {
                // 2023-02-23 Don't update count anymore because I have split the count since we are using the old announcement notification
                // let count = parseInt(countEl.data('count'));
                // if (isNaN(count)) count = 0;
                // if (count > 0) count--;
                // countEl.data('count', count);
                // countEl.text(count);
                // Don't set the cookie any more since we are clearing all notifications on the dashboard page.
                // setCookie('HpaMnCount', count.toString(), 1);
                // if (count == 0) {
                //     countEl.hide();
                // }
                closeButton.hide();
                mainParent.addClass('mn-status-1');

                $.ajax({
                  type: 'POST',
                  url: currenLocaleObj.urlPrefix + '/dashboard/member-notifications',
                  data: formData,
                  dataType: 'json',
                }).done(function (data) {
                    // console.log(data);
                });
            }

        });
    }
});



// WEBPACK FOOTER //
// ./js/modules/memberNotifications.js